import { Card, Flex, Icon, Text } from "@gravity-ui/uikit";
import classNames from "classnames";
import { Children, HTMLAttributes } from "react";

import css from "../SolutionBlock.module.scss";

export interface SolutionCardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  summary?: string;
  icon: (props: React.SVGProps<SVGSVGElement>) => React.JSX.Element;
}

export const SolutionCard = ({
  children,
  className,
  title,
  summary,
  icon,
}: SolutionCardProps) => {
  return (
    <Card className={classNames(css.card, className)}>
      <Flex alignItems={"center"} gap={4}>
        <div className={css.iconContainer}>
          <Icon data={icon} size={24} />
        </div>
        <Text variant="subheader-3">{title}</Text>
      </Flex>

      <ul>
        {Children.map(children, (child, index) => (
          <li key={`card.${title}.el.${index}`}>{child}</li>
        ))}
      </ul>

      {summary && <Text variant="subheader-1">{summary}</Text>}
    </Card>
  );
};
